import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import ReactSelect from 'react-select';
import { components } from '../../Utils/ReactSelectComponents';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import EditIcon from '@material-ui/icons/Edit';
import NegotiationSubLotLPGainAPI from '../../../API/NegotiationSubLotLPGainAPI';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import { handleServerError, handleSpecialCharacters } from '../../../Utils/Helper';

const modalStyles = theme => ({
  paper: {
    position: 'absolute',
    width: '50%',
    minWidth: 240,
    backgroundColor: theme.palette.background.paper
  },
  toolbarRoot: {
    padding: 0,
    backgroundColor: theme.palette.primary[500]
  },
  titleHead: {
    margin: '4px 12px',
    color: '#ffffff'
  },
  iconRight: {
    position: 'absolute',
    right: '12px',
    marginTop: '40px'
  },
  formRoot: {
    flexGrow: 1,
    margin: '12px'
  },
  width100: {
    width: '100%',
    textAlign: 'left'
  },
  footer: {
    display: 'flex',
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600],
    },
  },
  fabProgress: {
    position: 'absolute',
    right: 2,
    bottom: 2,
    zIndex: 1
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  tblAdd: {
    color: '#ffffff',
    borderRadius: '50%',
    border: '1px solid #ffffff'
  },
  paddingAlign: {
    paddingTop: '6px'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  }
});

function getModalPosition() {
  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
}

function InputCurrency(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        if (values.value.length <= 8) {
          onChange({ target: { value: values.value } });
        }
      }}
      decimalScale={2}
      thousandSeparator={'.'}
      decimalSeparator={','}
      allowNegative={true}
      suffix={'€'}
      isNumericString={true}
      allowEmptyFormatting={false}
      maxLength={12}
    />
  );
}
InputCurrency.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};


class NegotiationDiscountModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      loading: false,
      success: false,
      subLotLPGain: '',
      subLotLPGValue: '',
      observationsSubLotLPG: '',
      openError: false,
      alertMessage: ''
    };
  }

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
  };

  handleChange = name => event => {
    this.setState({ [name]: handleSpecialCharacters(event.target.value) });
  };

  handleOpen = (sublotLPGainData) => {
    let lpGainInfo = { value: sublotLPGainData.LPGainId, label: sublotLPGainData.LPGain };
    this.setState({
      openModal: true,
      subLotLPGain: lpGainInfo,
      subLotLPGValue: sublotLPGainData.Value == null ? null : sublotLPGainData.Value.toString(),
      observationsSubLotLPG: sublotLPGainData.SubLotLPGainObservations
    });
  };

  handleClose = () => {
    this.setState({
      openModal: false,
      subLotLPGain: '',
      subLotLPGValue: '',
      observationsSubLotLPG: ''
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleCreate = () => {
    const NegotiationSublotLPGain_API = new NegotiationSubLotLPGainAPI();
    this.setState({ loading: true })
    let negotiationNewL2LPGainDTO = this.parseStateForSubmit(this.state);
    NegotiationSublotLPGain_API.createSubLotLPGain(negotiationNewL2LPGainDTO).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          success: false,
        });
        this.handleClose();
        this.props.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };


  handleEdit = () => {
    const NegotiationSublotLPGain_API = new NegotiationSubLotLPGainAPI();
    this.setState({ loading: true })
    let negotiationEditL2LPGainDTO = this.parseStateForSubmit(this.state);
    NegotiationSublotLPGain_API.updateSubLotLPGain(negotiationEditL2LPGainDTO).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          success: false,
        });
        this.handleClose();
        this.props.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };

  parseStateForSubmit(estado) {
    return {
      SubLotLPGainId: this.props.sublotLPGainData ? this.props.sublotLPGainData.SubLotLPGainId : null,
      L2Id: this.props.L2ID,
      LPGainId: estado.subLotLPGain.value,
      Value: estado.subLotLPGValue,
      SubLotLPGainObservations: estado.observationsSubLotLPG
    };
  };

  render() {
    const { classes } = this.props;
    const { loading, success } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });

    return (
      <div>

        {this.props.newEditButton ?
          <Tooltip title='Nova Linha' placement='left-end' >
            <IconButton variant='fab' aria-label='New' disabled={!this.props.L2ID || this.props.estadoId !== 1} onClick={this.handleOpen} className={classes.buttonSizeTbl}>
              <AddIcon className={classes.tblAdd} />
            </IconButton>
          </Tooltip>
          :
          <Tooltip title='Editar' placement='bottom' >
            <IconButton aria-label='Edit' disabled={!this.props.L2ID || this.props.estadoId !== 1} onClick={() => { this.handleOpen(this.props.sublotLPGainData) }} className={classes.buttonSizeTbl} >
              <EditIcon />
            </IconButton>
          </Tooltip>
        }

        <Modal open={this.state.openModal} onClose={this.handleClose} disableAutoFocus={true}>
          <div style={getModalPosition()} className={classes.paper}>

            <Paper>
              <Toolbar className={classes.toolbarRoot}>
                {this.props.newEditButton ?
                  <Typography variant='title' id='newDiscountRow' className={classes.titleHead}>NOVA LINHA</Typography>
                  :
                  <Typography variant='title' id='editDiscountRow' className={classes.titleHead}>EDITAR LINHA</Typography>
                }
              </Toolbar>
            </Paper>

            <form className={classes.formRoot}>
              <Grid container spacing={8}>

                <Grid item xs={12} sm={6}>
                  {this.props.newEditButton ?
                    <Grid container justify='center'>
                      <div className={classes.width100}>
                        <InputLabel htmlFor='subLotLPGain'>
                          CÓDIGO / DESCRIÇÃO
                        </InputLabel>
                        <ReactSelect
                          classes={classes}
                          options={this.props.lpGainData}
                          components={components}
                          value={this.state.subLotLPGain}
                          onChange={this.handleChangeSelect('subLotLPGain')}
                          placeholder=''
                        />
                      </div>
                    </Grid>
                    :
                    <TextField
                      id='subLotLPGain'
                      label='CÓDIGO / DESCRIÇÃO'
                      fullWidth
                      value={this.state.subLotLPGain.label}
                      className={classes.paddingAlign}
                      InputProps={{ readOnly: true }}
                    />}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id='subLotLPGValue'
                    label='VALOR'
                    margin='dense'
                    fullWidth
                    value={this.state.subLotLPGValue}
                    onChange={this.handleChange('subLotLPGValue')}
                    InputProps={{ inputComponent: InputCurrency }}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField
                    id='observationsSubLotLPG'
                    label='OBSERVAÇÕES'
                    margin='normal'
                    fullWidth
                    multiline
                    rows='1'
                    rowsMax='3'
                    inputProps={{ maxLength: 500 }}
                    value={this.state.observationsSubLotLPG}
                    onChange={this.handleChange('observationsSubLotLPG')}
                  />
                </Grid>

              </Grid>

              <Toolbar className={classes.footer}>
                <div className={classes.iconRight}>
                  <Tooltip title='Cancelar' placement='bottom' >
                    <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClose}>
                      <CloseIcon />
                    </Button>
                  </Tooltip>

                  {this.props.newEditButton ?
                    <span>
                      <Tooltip title='Guardar' placement='bottom' >
                        <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.handleCreate}>
                          {success ? <CheckIcon /> : <SaveIcon />}
                        </Button>
                      </Tooltip>
                      {loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
                    </span>
                    :
                    <span>
                      <Tooltip title='Guardar' placement='bottom' >
                        <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.handleEdit}>
                          {success ? <CheckIcon /> : <SaveIcon />}
                        </Button>
                      </Tooltip>
                      {loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
                    </span>}

                </div>
              </Toolbar>

            </form>
          </div>
        </Modal>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    );
  }
}

NegotiationDiscountModal.propTypes = {
  classes: PropTypes.object.isRequired,
  L1ID: PropTypes.number.isRequired
};

export default NegotiationDiscountModal = withStyles(modalStyles)(NegotiationDiscountModal);


// WEBPACK FOOTER //
// ./src/components/Negotiation/DiscountTable/NegotiationDiscountModal.js